export default {"src":"/login-app/[GIT_HASH]/_next/static/media/logs_structured.b06226e8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};